import { convertFirstColumnToRowHeaders } from '../../../common/table-row-headers.js';
export { convertFirstColumnToRowHeaders } from '../../../common/table-row-headers.js';

const setResponsiveCellHeaders = (table, tableIndex) => {
    try {
        const THarray = [];
        table.classList.add(`table-${tableIndex}`);
        const ths = table.querySelectorAll('thead > tr > [role=columnheader]');
        for (const heading of ths) {
            const headingText = heading.innerHTML;
            THarray.push(headingText);
        }
        const styleElm = document.createElement('style');
        document.head.appendChild(styleElm);
        const styleSheet = styleElm.sheet;
        for (const [i, heading] of THarray.entries()) {
            const insertIndex = styleSheet ? styleSheet.cssRules.length : 0;
            styleSheet === null || styleSheet === void 0 ? void 0 : styleSheet.insertRule(`.table-${tableIndex} tbody td:nth-child(${i + 1})::before {content:"${heading}";}`, insertIndex);
        }
    }
    catch (e) {
        console.log(`setResponsiveCellHeaders(): ${e}`);
    }
};
const addAria = (elementSelector, attributeValue) => {
    const elements = document.querySelectorAll(elementSelector);
    for (const el of elements) {
        el.setAttribute('role', attributeValue);
    }
};
const rolesArr = [
    {
        selector: 'table',
        role: 'table',
    },
    {
        selector: 'thead, tbody, tfoot',
        role: 'rowgroup',
    },
    {
        selector: 'tr',
        role: 'row',
    },
    {
        selector: 'tbody td',
        role: 'cell',
    },
    {
        selector: 'th',
        role: 'columnheader',
    },
    {
        selector: 'thead > tr > *',
        role: 'columnheader',
    },
    {
        selector: 'th[scope=row]',
        role: 'rowheader',
    },
];
// https://adrianroselli.com/2018/02/tables-css-display-properties-and-aria.html
// https://adrianroselli.com/2018/05/functions-to-add-aria-to-tables-and-lists.html
const addTableARIA = () => {
    try {
        rolesArr.forEach(element => addAria(element.selector, element.role));
        // caption role not needed as it is not a real role and
        // browsers do not dump their own role with display block
    }
    catch (e) {
        console.log(`addTableARIA(): ${e}`);
    }
};
document.addEventListener('DOMContentLoaded', () => {
    const tables = [...document.querySelectorAll('table')];
    tables.forEach(table => convertFirstColumnToRowHeaders(table));
    addTableARIA();
    tables.forEach((table, index) => {
        setResponsiveCellHeaders(table, index + 1);
    });
});
// Observe DOM for tables added after initial load and process them
const tableMutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            var _a;
            if (!(node instanceof Element))
                return;
            const addedTables = [];
            if ((_a = node.matches) === null || _a === void 0 ? void 0 : _a.call(node, 'table'))
                addedTables.push(node);
            addedTables.push(...Array.from(node.querySelectorAll('table')));
            addedTables.forEach(table => {
                if (table.dataset.rteProcessed)
                    return;
                convertFirstColumnToRowHeaders(table);
                addTableARIA();
                const total = document.querySelectorAll('table').length;
                setResponsiveCellHeaders(table, total);
                table.dataset.rteProcessed = 'true';
            });
        });
    });
});
if (typeof window !== 'undefined' && window.MutationObserver) {
    tableMutationObserver.observe(document.body, { childList: true, subtree: true });
}

export { addAria, addTableARIA, setResponsiveCellHeaders };
